export default {"badge":"_8NP34"};